import React, { useEffect, useState, useMemo } from "react";
import { useAuth } from "react-oidc-context";
import { initialize } from "@iot-app-kit/source-iotsitewise";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-providers";
import { IoTSiteWiseClient } from "@aws-sdk/client-iotsitewise";
import { IoTEventsClient } from "@aws-sdk/client-iot-events";
import "react-time-picker/dist/TimePicker.css";
import { useTimeSeriesData } from "@iot-app-kit/react-components";
import { BatchPutAssetPropertyValueCommand } from "@aws-sdk/client-iotsitewise";
import { getStorkAssets } from "./sitewise";
import { labelMap } from "./sitewise";
import { buildEntriesDT } from "./sitewise";
import { buildEntries } from "./sitewise";
import { buildEntriesShift } from "./sitewise";
import { GetAssetPropertyValueHistoryCommand } from "@aws-sdk/client-iotsitewise";
import { GetAssetPropertyValueCommand } from "@aws-sdk/client-iotsitewise";
import "./App.css";
import { createContext, useRef } from "react";
import Shift from "./Shift";
import Main from "./Main";
import { navigationController } from "./utils/navigationControl";

export const PageContext = createContext(null);

// Main app component with all state and logic hooks
const App = () => {
  const auth = useAuth();
  const [query, setQuery] = useState(null);
  const [siteWiseClient, setSiteWiseClient] = useState(null);

  const site = "Nambour";
  const productLine = "Stork";
  const counterMaxTime = 3600; // changeover time when overtime negative

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // SITEWISE VALUES  ////

  const [valuesSW, setValuesSW] = useState({});
  const [batchID, setBatchID] = useState("");
  const [materialCode, setMaterialCode] = useState("");

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // PRODUCTION PLAN  ////

  const [productionPlan, setProductionPlan] = useState([]);

  useEffect(() => {

    console.log("materialCode latest value: ", materialCode); 

    if (materialCode === null || materialCode === undefined || materialCode === "") return;

    

    fetch(
      `https://13e529h0pi.execute-api.ap-southeast-2.amazonaws.com/prod/production-plan?material=${materialCode}`,

      {
        headers: {
          "x-api-key": "jdsfghsdgjsLJKHFDJFFJUD^&*$((#", // replace this
        },
      }
    )
      .then((res) => res.json())
      .then((data) => {
        setProductionPlan(data);
        console.log("Fetched plan data:", data);

        const downtimeReceived = data?.[0]?.planned_dwt_min ?? 0;
        setDuration(downtimeReceived * 60); // change duration in seconds
      })
      .catch(console.error);



    if (materialCode === 0 || materialCode === 99) {
      // Fetch with materialT value when current material is 0 or 99
      if (valuesSW.materialT && valuesSW.materialT !== 0 && valuesSW.materialT !== 99) {
        console.log("Fetching with materialT backup value:", valuesSW.materialT);
        
        fetch(
          `https://13e529h0pi.execute-api.ap-southeast-2.amazonaws.com/prod/production-plan?material=${valuesSW.materialT}`,
          {
            headers: {
              "x-api-key": "jdsfghsdgjsLJKHFDJFFJUD^&*$((#",
            },
          }
        )
          .then((res) => res.json())
          .then((data) => {
            
            
            // Only update the downtime duration, keep existing productionPlan
            const downtimeReceived = data?.[0]?.planned_dwt_min ?? 0;
            setDuration(downtimeReceived * 60);
            console.log("Fetched plan data using materialT:", data);
        
          })
          .catch((err) => {
            console.error("Failed to fetch backup production plan:", err);
          });
      } else {
        console.log("No valid materialT backup value available");
  
      }
    }
  }, [materialCode, valuesSW.materialT]); 

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // PROGRESS BAR AND ESTIMATED FINISH TIME ////

  const [progressPercentage, setProgressPercentage] = useState([]);
  const [estimatedFinishTime, setEstimatedFinishTime] = useState("");
  const [plannedFinishTime, setPlannedFinishTime] = useState("");
  const [timestampStartTime, setTimestampStartTime] = useState("");
  const [estimatedFinishColor, setEstimatedFinishColor] = useState("black");

  useEffect(() => {
    if (productionPlan.length == 0) return;
    // if (productionPlan.length == 0 || !materialCode ) return;

    const total = productionPlan[0].units_to_make; // total bottles to make
    const currentCount = valuesSW.productionCount; // bottles made so far

    // console.log("total", total);
    // console.log("currentCount", currentCount);

    let percentage = 0;

    if (currentCount > 0) {
      percentage = Math.floor((currentCount * 100) / total);
    }

    setProgressPercentage(percentage);

    const plannedFinishTimeReceived = productionPlan[0].planned_finish; // this will be received: "2024-12-23 12:19:55"

    const plannedDate = new Date(plannedFinishTimeReceived.replace(" ", "T"));
    const plannedTimeStr = plannedDate.toLocaleTimeString("en-AU", {
      hour12: false,
    });
    setPlannedFinishTime(plannedTimeStr);

    let parsed = {};
    try {
      if (valuesSW.EventsJSON) {
        parsed = JSON.parse(valuesSW.EventsJSON);
      }
    } catch (err) {
      console.warn("Failed to parse EventsJSON:", err);
    }

    const timestamp = parsed?.Material?.ChangeTimestamp;

    let estSecondsLeft = 0;

    if (timestamp) {
      const changeDate = new Date(timestamp.replace(" ", "T"));
      setTimestampStartTime(changeDate);

      const now = new Date();
      const elapsedSeconds = Math.floor((now - changeDate) / 1000);

      const bottlesLeft = total - currentCount;

      if (currentCount > 0 && elapsedSeconds > 0) {
        const rate = currentCount / elapsedSeconds;
        estSecondsLeft = Math.floor(bottlesLeft / rate);
      }

      // console.log("changeDate:", changeDate);
      // console.log("currentCount:", currentCount);
      // console.log("total:", total);
      // console.log("bottlesLeft:", bottlesLeft);
    }

    // console.log("estSecondsLeft:", estSecondsLeft);

    const estFinishDate = new Date(now.getTime() + estSecondsLeft * 1000);

    const timeDiffSeconds = Math.floor((estFinishDate - plannedDate) / 1000); // use this

    // const plannedDateTest = new Date(now.getTime() + (estSecondsLeft + 400) * 1000);  // just for testing
    // const timeDiffSeconds = Math.floor((plannedDateTest - estFinishDate) / 1000);   // this is just for testing

    // console.log("timeDifference:", timeDiffSeconds);

    if (timeDiffSeconds > 600) {
      setEstimatedFinishColor("red");
    } else if (timeDiffSeconds > 300) {
      setEstimatedFinishColor("orange");
    } else {
      setEstimatedFinishColor("black");
    }

    const estTimeStr = estFinishDate.toLocaleTimeString("en-AU", {
      hour12: false,
    });

    setEstimatedFinishTime(estTimeStr);
  }, [valuesSW]); // TODO: LATER change to valuesSW.productionCount

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // SHIFT VALUES AND PROCESSING ////

  const [shiftStart, setShiftStart] = useState("");
  const [shiftEnd, setShiftEnd] = useState("");
  const [pendingShiftStart, setPendingShiftStart] = useState("");

  const [shiftPage, setShiftPage] = useState(null);
  const [shiftValuesReceived, setShiftValuesReceived] = useState(false);
  const flag = useRef(false);

  const [shiftConfirmed, setShiftConfirmed] = useState(false);
  const [shiftStillInProgress, setShiftStillInProgress] = useState(true);
  const [shiftDuration, setShiftDuration] = useState(0);
  const [shiftInitChecked, setShiftInitChecked] = useState(false);
  const [viewportDuration, setViewportDuration] = useState(0);

  const getLocalISOString = () => {
    const now = new Date();
    const offset = now.getTimezoneOffset();
    const localDate = new Date(now.getTime() - offset * 60 * 1000);
    return localDate.toISOString().slice(0, 16);
  };

  const [nowISOString, setNowISOString] = useState(getLocalISOString());

  useEffect(() => {
    const interval = setInterval(() => {
      setNowISOString(getLocalISOString());
    }, 60000); // update every 1 minute

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (!shiftValuesReceived) return;

    const startDate = new Date(shiftStart);
    const endDate = new Date(shiftEnd);

    // Ensure both are valid before comparing
    const isStartValid = !isNaN(startDate);
    const isEndValid = !isNaN(endDate);

    if (isStartValid && isEndValid) {
      if (startDate >= endDate) {
        setShiftPage(false); // go to main (shift ended)
      } else {
        setShiftPage(true); // shift still in progress or just starting
      }
    }
  }, [shiftValuesReceived]);

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // VIEWPORT SHIFT DURATION - PROBABLY DONT NEED IT ANYMORE.

  useEffect(() => {
    const interval = setInterval(() => {
      const start = shiftStart;
      const end = shiftEnd;

      if (!start || start === "test") {
        setShiftDuration(0);
        setViewportDuration(0); // also reset
        return;
      }

      const startDate = new Date(start);
      const endDateParsed = new Date(end);
      const now = new Date();

      const endDate = !end || startDate > endDateParsed ? now : new Date(end);

      const diffInSeconds = Math.floor((endDate - startDate) / 1000);
      const viewportSeconds = Math.floor((now - startDate) / 1000); // from start to now

      setShiftDuration(diffInSeconds);
      // setViewportDuration(viewportSeconds);

      const seconds = Math.floor((now - startDate) / 1000);

      // TODO: fix this later for graphs and trends
      setViewportDuration((prev) => {
        return Math.abs(prev - seconds) >= 100 ? seconds : prev;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [shiftStart, shiftEnd]);

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // COUNTDOWN TIMER FOR CHANGEOVER
  const changeoverPlannedTime = 1800; // Value just in case is missing
  const [changeoverDLast, setChangeoverDLast] = useState(0);

  const [duration, setDuration] = useState(changeoverPlannedTime);
  const [timerKey, setTimerKey] = useState(0);

  const [countdownInitialTime, setCountdownInitialTime] = useState(0);
  const [changeoverMode, setChangeoverMode] = useState(null);

  const [manualOvertime, setManualOvertime] = useState(false);

  useEffect(() => {
    if (valuesSW.changeover == null) return;

    if (manualOvertime) {
      setManualOvertime(false); // skip once
      return;
    }

    const plannedSeconds = duration;
    const elapsedSeconds = changeoverDLast;
    const changeoverTimeLeft = plannedSeconds - elapsedSeconds;

    // console.log("changeoverTimeLeft", changeoverTimeLeft);

    if (valuesSW.changeover == "true") {
      if (changeoverTimeLeft > 0) {
        setCountdownInitialTime(changeoverTimeLeft);
        // console.log("setChangeoverMode false");
        setChangeoverMode(false);
      } else {
        setCountdownInitialTime(counterMaxTime - Math.abs(changeoverTimeLeft)); // i need to flip the logic here
        setChangeoverMode(true); // its in overtime
        // console.log("setChangeoverMode true");
      }
      setTimerKey((prev) => prev + 1); // force remount with new state
    } else {
      console.log("setChangeoverMode false again");
      setChangeoverMode(false); // not in changeover = no timer
    }
  }, [valuesSW.changeover, valuesSW.changeoverD]);

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // DOWNTIME ENTRY VARIABLES

  const [showPopup, setShowPopup] = useState(false);

  const [pendingStartTime, setPendingStartTime] = useState("12:00");
  const [startTime, setStartTime] = useState("");

  const [pendingEndTime, setPendingEndTime] = useState("12:30");
  const [endTime, setEndTime] = useState("");

  const [pendingCode, setPendingCode] = useState("");
  const [code, setCode] = useState("");

  const [pendingComment, setPendingComment] = useState("");
  const [comment, setComment] = useState("");

  const [downtime, setDowntime] = useState(0);
  const [totalDowntime, setTotalDowntime] = useState(0);
  const [totalAutoDowntime, setTotalAutoDowntime] = useState(0);

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // SITEWISE AUTH  ////

  useEffect(() => {
    const fetchData = async () => {
      if (!auth.isAuthenticated || !auth.user?.id_token) return;

      const credentials = fromCognitoIdentityPool({
        identityPoolId: "ap-southeast-2:a9b6dec3-c838-424e-aca5-c82145f1ef97", // ap-southeast-2:a9b6dec3-c838-424e-aca5-c82145f1ef97 - lactalis, ap-southeast-2:71e633df-115c-41e4-a449-9eb64a1750b3 - shorelinq
        clientConfig: { region: "ap-southeast-2" },
        logins: {
          "cognito-idp.ap-southeast-2.amazonaws.com/ap-southeast-2_ly5xUVaHX":
            auth.user.id_token, // ly5xUVaHX - lactalis, brAkmJJ1v - shorelinq
        },
      });

      try {
        const creds = await credentials();
        console.log("✅ Logged in with Cognito!", creds);

        const siteWiseClient = new IoTSiteWiseClient({
          region: "ap-southeast-2",
          credentials,
        });

        setSiteWiseClient(siteWiseClient); // its for sending data

        const eventsClient = new IoTEventsClient({
          region: "ap-southeast-2",
          credentials,
        });

        const { query } = initialize({
          iotSiteWiseClient: siteWiseClient,
          iotEventsClient: eventsClient,
        });

        setQuery(query);
      } catch (err) {
        console.error("❌ Failed to initialize AWS clients:", err);
      }
    };

    fetchData();
  }, [auth]);

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // RECEIVE LATEST SITEWISE DATA  - it returns a single value only//

  useEffect(() => {
    if (!siteWiseClient) return;

    const interval = setInterval(async () => {
      const batchIDObject = await siteWiseClient.send(
        new GetAssetPropertyValueCommand({
          assetId: "e1a3a968-9859-4473-a4b2-15b033aa6843",
          propertyId: "46ab1432-86b5-4efe-8f29-a0449a606dbb",
        })
      );
      const materialObject = await siteWiseClient.send(
        new GetAssetPropertyValueCommand({
          assetId: "e1a3a968-9859-4473-a4b2-15b033aa6843",
          propertyId: "cba8600b-e20a-4a73-8390-a3400ed245d7",
        })
      );

      const shiftStartObject = await siteWiseClient.send(
        new GetAssetPropertyValueCommand({
          assetId: "e1a3a968-9859-4473-a4b2-15b033aa6843",
          propertyId: "73c6fd17-d1bc-4a2e-9db6-2ef78c1c0748",
        })
      );

      const shiftEndObject = await siteWiseClient.send(
        new GetAssetPropertyValueCommand({
          assetId: "e1a3a968-9859-4473-a4b2-15b033aa6843",
          propertyId: "354ff583-e8aa-4d14-9faa-4ee322fae63b",
        })
      );

      const warningAutoBinaryObject = await siteWiseClient.send(
        new GetAssetPropertyValueCommand({
          assetId: "3b1e0495-7065-466c-91ed-3ae21dbe529a",
          propertyId: "9ee04336-cb4b-4085-a8d0-afde8731b38c",
        })
      );

      setBatchID(batchIDObject.propertyValue?.value?.stringValue);
      // setMaterialCode(materialObject.propertyValue?.value?.stringValue);
      setShiftStart(shiftStartObject.propertyValue?.value?.stringValue);
      setShiftEnd(shiftEndObject.propertyValue?.value?.stringValue);

      const prodNumRaw = materialObject.propertyValue?.value?.stringValue;
      const prodNum = parseInt(prodNumRaw, 10); // convert string to integer


      setMaterialCode(materialCodeMap[prodNum]);

      if (!flag.current) {
        flag.current = true;

        setShiftValuesReceived(true);
      }

      const warningAutoBinary =
        warningAutoBinaryObject.propertyValue?.value?.integerValue;

      if (typeof warningAutoBinary === "number" && warningAutoBinary !== 0) {
        const currentWarnings = [];

        for (let i = 0; i < 32; i++) {
          if ((warningAutoBinary & (1 << i)) !== 0) {
            const label = warningBitLabels[i] || `Unknown Bit ${i}`;
            currentWarnings.push(label);
          }
        }

        const warningText = currentWarnings.join(", ");
        setWarningEventsCurrent(warningText);
      } else {
        setWarningEventsCurrent("No warnings");
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [siteWiseClient]);

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // SENDING SITEWISE DATA //

  const sendToSiteWise = async (values) => {
    if (!siteWiseClient) {
      console.error("SiteWise client is not initialized yet.");
      return;
    }

    const entries = buildEntries(values);
    

    const command = new BatchPutAssetPropertyValueCommand({ entries });

    try {
      await siteWiseClient.send(command);
      console.log("✅ All downtime values sent to SiteWise");
    } catch (err) {
      console.error("❌ Failed to send downtime batch:", err);
    }
  };

  const sendToSiteWiseShift = async (values) => {
    if (!siteWiseClient) {
      console.error("SiteWise client is not initialized yet.");
      return;
    }

    const entries = buildEntriesShift(values);


    const command = new BatchPutAssetPropertyValueCommand({ entries });

    try {
      await siteWiseClient.send(command);
      console.log("✅ All downtime values sent to SiteWise");
    } catch (err) {
      console.error("❌ Failed to send downtime batch:", err);
    }
  };

  const sendToSiteWiseDT = async (values) => {
    if (!siteWiseClient) {
      console.error("SiteWise client is not initialized yet.");
      return;
    }

    const entries = buildEntriesDT(values);
 

    const command = new BatchPutAssetPropertyValueCommand({ entries });

    try {
      await siteWiseClient.send(command);
      console.log("✅ All downtime values sent to SiteWise");
    } catch (err) {
      console.error("❌ Failed to send downtime batch:", err);
    }
  };

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // QUERING SITEWISE DATA USING TIME SERIES DATA//

  const timeSeriesData = useMemo(() => {
    if (!query)
      return {
        queries: [],
        viewport: { duration: "0m" },
      };

    const defaultViewport =
      viewportDuration > 0
        ? { duration: `${Math.ceil(viewportDuration / 60)}m` }
        : { duration: "720m" };

    const timeSeries = query.timeSeriesData({
      assets: getStorkAssets(),
      requestSettings: { refreshRate: 1000 },
    });

    return {
      queries: [timeSeries],
      viewport: defaultViewport,
    };
  }, [query, viewportDuration]);

  const { dataStreams } = useTimeSeriesData(timeSeriesData);

  // TODO: use this for the actual shift period for trends and graphs. but need to check other values that need the latest value.
  // viewport: {
  //   start: shiftStart,
  //   end: shiftEnd || new Date().toISOString()
  // }

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // UPDATING VARIABLES FROM SITEWISE READINGS//

  useEffect(() => {
    const now2 = new Date();
    const formattedDateTime2 = now2.toLocaleString("en-AU", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });
    // console.log("Component re-rendered " + formattedDateTime2); //- use this later for polling code

    let mins = 0;
    let secs = 0;

    dataStreams.forEach((stream, index) => {
      const value = stream.data?.at(-1)?.y;
      const label = labelMap[index];

      if (!label || value == null) return;

      let updated = value;

      if (label.startsWith("DT")) {
        updated = stream.data.map((point) => ({
          timestamp: point.x,
          value: point.y,
        }));
      }

      // Find last valid materialT (not 0 or 99) from last 5 values
      if (label === "materialT") {
        // TEMPORARY DEBUG CODE - print all last 5 values
        // const lastFiveValues = stream.data.slice(-5);
        // console.log("Last 5 materialT values:", lastFiveValues.map(p => ({ timestamp: p.x, value: p.y })));
        
        const valid = stream.data
          .slice(-5) // take last 5
          .reverse() // so latest is first
          .find((p) => p.y !== "0" && p.y !== "99"); // Compare as strings, not numbers

        if (valid) {
          const materialTValue = valid.value ?? valid.y;
          const mappedMaterialT = materialCodeMap[parseInt(materialTValue, 10)];
          
          setValuesSW((prev) => ({ ...prev, materialT: mappedMaterialT }));
          // console.log("materialT (raw):", materialTValue, "→ (mapped):", mappedMaterialT);
        } else {
          console.log("⚠️ No valid materia Code in last 5 points.");
        }
      } else {
        setValuesSW((prev) => ({ ...prev, [label]: updated }));
      }

      if (label === "changeoverMins") {
        mins = value;
      }

      if (label === "changeoverSeconds") {
        secs = Math.floor(value); // ensure it's an integer
      }
    });

    setChangeoverDLast(mins * 60 + secs);
  }, [dataStreams]);

  const now = new Date();

  const formattedDateTime = now.toLocaleString("en-AU", {
    year: "numeric",
    month: "short", // e.g. "Apr"
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false, // 24-hour format; remove if you prefer AM/PM
  });

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // EVENT DURATIONS HANDLING//

  const [currentMode, setCurrentMode] = useState("No Status");
  const [warningEvents, setWarningEvents] = useState("");
  const [warningEventsCurrent, setWarningEventsCurrent] = useState("");

  const [DTAutoEvents, setDTAutoEvents] = useState("");
  const [DTManualEvents, setDTManualEvents] = useState("");

  const statusLabels = {
    [-1]: "No Status",
    0: "No Run Mode",
    2: "External Clean Mode",
    3: "CIP Mode",
    4: "Idle Mode",
    5: "Filling Mode",
  };

  useEffect(() => {
    const statusNumber = valuesSW.currentMode;

    if (statusNumber == null) {
      setCurrentMode("No Status Returned");
      return;
    }

    const label = statusLabels[statusNumber];

    setCurrentMode(label);
  }, [valuesSW.currentMode]);

  // IT PROVIDES EVENT NAME AND TOTAL DURATION FOR EACH EVENT
  const handlePropertyHistoryResponse = (historyArray, typeEvents) => {
    if (!Array.isArray(historyArray)) {
      console.warn("No valid history array");
      return;
    }

    const durations = {};

    let total = 0;

    const startDateParsed = new Date(shiftStart);
    const endDateParsed = new Date(shiftEnd);
    const now = new Date(Date.now() - 10000); // 10 seconds ago just do displaying purposes if the event is on right now

    const shiftStartDate = new Date(`${shiftStart}:00+10:00`);

    const shiftEndDate =
      !shiftEnd || startDateParsed > endDateParsed
        ? now
        : new Date(`${shiftEnd}:00+10:00`);

    let valueFoundBeforeShift = false;

    // 1Find the latest value BEFORE shiftStart
    const firstBeforeShift = [...historyArray]
      .reverse()
      .find(
        (entry) =>
          new Date(entry.timestamp.timeInSeconds * 1000) < shiftStartDate
      );

    if (firstBeforeShift) {
      const val =
        firstBeforeShift.value.integerValue ??
        firstBeforeShift.value.doubleValue ??
        firstBeforeShift.value.stringValue ??
        firstBeforeShift.value.booleanValue ??
        null;

      const nextTs = historyArray.find((entry) => {
        const ts = new Date(entry.timestamp.timeInSeconds * 1000);
        return ts >= shiftStartDate;
      });

      const nextTime = nextTs
        ? new Date(nextTs.timestamp.timeInSeconds * 1000)
        : shiftEndDate;

      const durationSec = Math.floor((nextTime - shiftStartDate) / 1000);
      if (typeof val === "number" && val !== 0 && durationSec > 0) {
        durations[val] = (durations[val] || 0) + durationSec;
        total += durationSec;
      }
    } else {
      if (typeEvents != "DowntimeCode") {
        console.warn("Value was not found for ", typeEvents);
        // sendToSiteWise({
        //   logsSW: `Value was not found for ${typeEvents}`,
        // });
      }
    }

    // Filter entries within the shift window only
    const shiftEntries = historyArray.filter((entry) => {
      const ts = new Date(entry.timestamp.timeInSeconds * 1000);
      return ts >= shiftStartDate && ts <= shiftEndDate;
    });

    // Middle durations
    shiftEntries.forEach((entry, idx) => {
      const { value, timestamp } = entry;
      const ts = new Date(timestamp.timeInSeconds * 1000);

      const val =
        value.integerValue ??
        value.doubleValue ??
        value.stringValue ??
        value.booleanValue ??
        null;

      if (idx < shiftEntries.length - 1) {
        const nextTs = new Date(
          shiftEntries[idx + 1].timestamp.timeInSeconds * 1000
        );
        const durationSec = Math.floor((nextTs - ts) / 1000);
        if (typeof val === "number" && val !== 0 && durationSec > 0) {
          durations[val] = (durations[val] || 0) + durationSec;
          total += durationSec;
        }
      }
    });

    // Final duration to shift end
    const last = shiftEntries.at(-1);
    if (last) {
      const ts = new Date(last.timestamp.timeInSeconds * 1000);
      const val =
        last.value.integerValue ??
        last.value.doubleValue ??
        last.value.stringValue ??
        last.value.booleanValue ??
        null;

      const durationSec = Math.floor((shiftEndDate - ts) / 1000);
      if (typeof val === "number" && val !== 0 && durationSec > 0) {
        durations[val] = (durations[val] || 0) + durationSec;
        total += durationSec; // total duration
      }
    }

    return [durations, total];
  };

  const warningBitLabels = {
    1: "Grease Pulse Error",
    2: "Cap Supply Low",
    3: "Product Tank Low",
    4: "Infeed Bottle Supply Low",
    5: "warningTest1",
    6: "warningTest2",
    7: "warningTest3",
  };

  const downtimeBitLabels = {
    1: "Waiting for Bottles In",
    2: "Waiting for Hartness Out",
    3: "Fallen Bottle",
    4: "Infeed Starwheel Jam",
    5: "Filler to Capper Starwheel Jam",
    6: "Outfeed Starwheel Jam",
    7: "Product Tank Empty",
    8: "Operator Stop",
    9: "Emergency Stop",
    10: "Cap Chute Error",
    11: "DT Test",
  };

  const decodeBitmaskDurations = (durationMap, bitLabels) => {
    const bitDurations = {};

    for (const [bitmaskStr, seconds] of Object.entries(durationMap)) {
      const bitmask = parseInt(bitmaskStr);

      if (bitmask === 0) {
        continue;
      }

      for (let i = 0; i < 32; i++) {
        if ((bitmask & (1 << i)) !== 0) {
          bitDurations[i] = (bitDurations[i] || 0) + seconds;
        }
      }
    }
    return Object.entries(bitDurations).map(([bit, seconds]) => {
      const label = bitLabels[bit] || `Unknown Bit ${bit}`;
      return { label, seconds };
    });
  };

  const materialCodeMap = {
    0: 0, // no material during rinses and cleaning

    3: 40141, // BREAKA FLAV MILK ICED COFFEE 300ML BTL
    4: 39714, // BREAKA FLAV MILK CHOCOLATE 300ML BTL
    5: 39650, // BREAKA FLAV MILK STRAWBERRY 300ML BTL
    11: 16010, // ICE BREAK FLAV MILK ICE/COFF 500ML
    12: 74956, // ICE BREAK FLAV MILK MOCHA 500ML
    13: 73063, // IB STRONG ESPRESSO PROTEIN FM 500ML
    14: 41275, // ICE BREAK TRIPLE SHOT ICE COFFEE 500ML
    16: 70992, // ICE BREAK FLAV MILK NSA COFFEE 500ML
    17: 14488, // BREAKA FLAV MILK LIME 500ML
    18: 1708, // BREAKA FLAV MILK ICED COFFEE 500ML
    19: 1695, // BREAKA FLAV MILK CHOCOLATE 500ML
    20: 46141, // BREAKA FLAV MILK BANANA 500ML
    22: 228520, // BREAKA WEIS MANGO & CREAM FM EAM 500ML
    24: 1724, // BREAKA FLAV MILK STRAWBERRY 500ML
    31: 34817, // PAULS FULL CREAM MILK 500ML
    34: 16110, // ICE BREAK FLAV MILK ICE COFFEE 750ML
    35: 41339, // ICE BREAK TRIPLE SHOT ICE COFFEE 750ML
    37: 37006, // BREAKA FLAV MILK CHOCOLATE 750ML
    38: 45196, // OAK FLAVOURED MILK ICED COFFEE 750ML
    39: 42112, // OAK FLAVOURED MILK CHOCOLATE 750ML
    40: 47933, // OAK FLAVOURED MILK STRAWBERRY 750ML
    41: 74965, // ICE BREAK FLAV MILK MOCHA 750ML
    43: 77333, // ICE BREAK FLAV MILK NSA COFFEE 750ML
    45: 16598, // ICE BREAK FLAV MILK ICE COFFEE 1.25L

    99: 99, // no material. drives filler bow up to maximum height
  };

  const DTManualLabelMap = {
    1: "Sanitise/Setup",
    2: "Product Changeover",
    3: "Packaging Changeover",
    4: "CIP/Cleaning (incl. manual cleaning)",
    5: "Preventative Maintenance",
    6: "Staff Related - Planned",
    8: "Mid Production Sanitise",
    10: "Size Changeover",
    11: "Waiting - Product",
    12: "Waiting - Materials",
    15: "Waiting - Cold room",
    16: "Waiting - Crates",
    17: "Waiting - Test",
    18: "Waiting - Staff Related - Unplanned",
    19: "Waiting - Packing",
    20: "Waiting - Material Restocking",
    24: "Waiting - CIP",
    29: "Fault - Unscrambler",
    30: "Fault - Infeed",
    33: "Fault - Labelling",
    34: "Fault - Coding",
    35: "Fault - Filling",
    36: "Fault - Lidding",
    37: "Fault - Sealing",
    38: "Fault - Capping",
    40: "Fault - Outfeed",
    48: "Fault - Pack Sterilisation",
    49: "Fault - Packaging",
    50: "Fault - Multipack",
    51: "Fault - Crate Packing",
    52: "Fault - Carton/Box Packing",
    53: "Fault - Crate Stacking",
    54: "Fault - Palletising",
    55: "Fault - Downstream Conveying/Transfer",
    56: "Fault - TUN Labelling",
    70: "Other - Site Related Downtime",
    80: "Fault - CIP",
    95: "Fault - Crate Broken",
    99: "Partial Interrupt",
    115: "Waiting - Raw milk unavailable",
  };

  useEffect(() => {
    if (!siteWiseClient || !shiftStart || !shiftEnd) return;

    const interval = setInterval(async () => {
      const rawStart = new Date(`${shiftStart}:00+10:00`);
      const start = new Date(Math.floor(rawStart.getTime() / 1000) * 1000);
      const startDateParsed = new Date(shiftStart);
      const endDateParsed = new Date(shiftEnd);
      const end =
        !shiftEnd || startDateParsed > endDateParsed
          ? new Date(Math.floor(Date.now() / 1000) * 1000)
          : new Date(
              Math.floor(new Date(`${shiftEnd}:00+10:00`).getTime() / 1000) *
                1000
            );
      const bufferStartDate = new Date(start.getTime() - 8 * 60 * 60 * 1000);

      const fetchAllPages = async (propertyId) => {
        let all = [],
          nextToken = null;
        do {
          const res = await siteWiseClient.send(
            new GetAssetPropertyValueHistoryCommand({
              assetId: "3b1e0495-7065-466c-91ed-3ae21dbe529a",
              propertyId,
              startDate: bufferStartDate,
              endDate: end,
              timeOrdering: "ASCENDING",
              nextToken,
            })
          );
          all.push(...(res.assetPropertyValueHistory || []));
          nextToken = res.nextToken;
        } while (nextToken);
        return all;
      };

      try {
        const [modeRaw, warningRaw, dtRaw, DowntimeManualCode] =
          await Promise.all([
            fetchAllPages("8179e9cb-2901-4d9e-9927-c865fe62da04"), // mode
            fetchAllPages("9ee04336-cb4b-4085-a8d0-afde8731b38c"), // warning
            fetchAllPages("5e787646-4082-4c55-bbcf-7cccc36b5038"), // downtime
            fetchAllPages("9d17e271-dfc1-46c7-8ae4-74d6b1642001"), // DowntimeManualCode
          ]);

        const [_, __] = handlePropertyHistoryResponse(modeRaw, "Mode"); // ignore for now
        const [warnings, __w] = handlePropertyHistoryResponse(
          warningRaw,
          "Warning"
        );
        const [DTEvents, totalDT] = handlePropertyHistoryResponse(
          dtRaw,
          "Downtime"
        );
        const [DTCodeEvents, totalCode] = handlePropertyHistoryResponse(
          DowntimeManualCode,
          "DowntimeCode"
        );

        // console.log("DTCodeEvents: ", DTCodeEvents);

        const manualEventsArray = Object.entries(DTCodeEvents).map(
          ([label, seconds]) => {
            const code = parseInt(label, 10);
            return {
              label: DTManualLabelMap[code] || `Code ${label}`,
              seconds,
            };
          }
        );

        // console.log("Warning events Raw: ", warningRaw);

        setDTManualEvents(manualEventsArray);

        setTotalDowntime(totalCode / 60);

        setDTAutoEvents(decodeBitmaskDurations(DTEvents, downtimeBitLabels));
        setTotalAutoDowntime(totalDT);

        setWarningEvents(decodeBitmaskDurations(warnings, warningBitLabels));

        const test = decodeBitmaskDurations(warnings, warningBitLabels);

        // console.log("Warning events: ", test);
      } catch (err) {
        console.error("Failed to fetch history:", err);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [siteWiseClient, shiftStart, shiftEnd]);

  // Handle authentication state changes for navigation control
  useEffect(() => {
    navigationController.setAuthenticationState(auth.isAuthenticated);

    if (auth.isAuthenticated) {
      // Clear any sign-in related history when user successfully authenticates
      navigationController.clearAuthHistory();
    }
  }, [auth.isAuthenticated]);

  // Prevent back navigation when authenticated
  useEffect(() => {
    if (auth.isAuthenticated) {
      const handlePopState = (event) => {
        // If user tries to navigate back while authenticated
        const currentPath = window.location.pathname;

        // Prevent going to Cognito sign-in URLs or login pages
        if (currentPath.includes("cognito") || currentPath.includes("login")) {
          event.preventDefault();
          // Force stay on main app
          window.history.pushState(null, "", "/");
        }
      };

      window.addEventListener("popstate", handlePopState);

      return () => {
        window.removeEventListener("popstate", handlePopState);
      };
    }
  }, [auth.isAuthenticated]);

  // AUTH LOADING GATE
  if (auth.isLoading)
    return (
      <div className="message">
        <p>Loading authentication...</p>
      </div>
    );
  if (auth.error)
    return (
      <div className="message">
        <p>Auth error: {auth.error.message}</p>
      </div>
    );

  if (!auth.isAuthenticated) {
    return (
      <div className="message">
        <img
          src="/LactalisLogo.png"
          alt="Lactalis Logo"
          style={{ width: "150px", marginBottom: "16px" }}
        />
        <button
          onClick={() => {
            // Use replace instead of redirect to prevent back navigation
            auth.signinRedirect();
          }}
        >
          Sign in
        </button>
      </div>
    );
  }

  if (
    !query ||
    Object.keys(valuesSW).length === 0 ||
    !shiftStart ||
    shiftPage === null
  ) {
    return (
      <div className="message">
        <p>Loading SiteWise data...</p>
      </div>
    );
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // SHIFT PAGE RETURN//

  if (shiftPage) {
    return (
      <PageContext.Provider
        value={{
          setShiftPage,
          shiftStart,
          setShiftStart,
          shiftEnd,
          setShiftEnd,
          pendingShiftStart,
          setPendingShiftStart,
          shiftStillInProgress,
          setShiftStillInProgress,
          setShiftConfirmed,
          sendToSiteWise,
          sendToSiteWiseShift,
          now,
          nowISOString,
          shiftPage,
        }}
      >
        <Shift />
      </PageContext.Provider>
    );
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // MAIN PAGE RETURN//
  if (!shiftPage) {
    return (
      <PageContext.Provider
        value={{
          warningEventsCurrent,
          sendToSiteWiseShift,
          estimatedFinishColor,
          estimatedFinishTime,
          plannedFinishTime,
          totalAutoDowntime,
          DTAutoEvents,
          DTManualEvents,
          progressPercentage,
          setShiftPage,
          now,
          formattedDateTime,
          timerKey,
          setTimerKey,
          downtime,
          nowISOString,
          shiftStart,
          shiftEnd,
          setEndTime,
          countdownInitialTime,
          duration,
          changeoverMode,
          setCountdownInitialTime,
          setManualOvertime,
          setChangeoverMode,
          counterMaxTime,
          currentMode,
          valuesSW,
          totalDowntime,
          pendingStartTime,
          setPendingStartTime,
          pendingEndTime,
          setPendingEndTime,
          pendingCode,
          setPendingCode,
          pendingComment,
          setPendingComment,
          setShowPopup,
          showPopup,
          setStartTime,
          setCode,
          setComment,
          setDowntime,
          sendToSiteWise,
          sendToSiteWiseDT,
          productionPlan,
          site: "Nambour",
          productLine: "Stork",
          batchID,
        }}
      >
        <Main />
      </PageContext.Provider>
    );
  }
};

export default App;
